export type UtmParameters = {
  source: string
  campaign: string
  content: string
  medium?: 'organic_social' | 'email' | 'referral'
}

export function withUtm(input: string, parameters: UtmParameters): URL {
  const url = new URL(input, window.location.origin)
  url.searchParams.set('utm_source', parameters.source)
  url.searchParams.set('utm_medium', parameters.medium ?? 'organic_social')
  url.searchParams.set('utm_campaign', parameters.campaign)
  url.searchParams.set('utm_content', parameters.content)
  return url
}
